export default __webpack_public_path__ + "static/media/nners_raceweek_1000_cochemoto_330x330.f64e3d02.webp";